enum CustomerPhoneGroup {
  PRIMARY = 'PRIMARY',
  ALTERNATIVE = 'ALTERNATIVE',
}

export default CustomerPhoneGroup;
